import { sendGoogleEvent } from 'html/include/pw/_common/utils';

const createOnClickTracker = (blockName) => (e) => {
  const $button = $(e.currentTarget);
  const ctaLabel = $button.data('label');
  if ($button.data('should-track')) {
    sendGoogleEvent(
      'CLP Blocks',
      blockName,
      ctaLabel,
      {
        ampEventName: 'clp_block_clicked',
        clpBlockName: blockName,
        clpCTAName: ctaLabel,
      },
    );
  }
};

export default createOnClickTracker;
